import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';

import RsBreadcrumbTooltip from '@Pages/RetroSynthesis/RsBreadcrumbs/RsBreadcrumbTooltip';

const linkToId = (link) => link.replace(/\//gi, '-');

function RsBreadcrumbItem({ link, iconName, label, className, active, disabled, children, ariaLabel }) {
  return (
    <li
      className={cn('new-breadcrumbs__item', { 'new-breadcrumbs__item--active': active }, className)}
      data-tip
      data-for={`tooltip-${linkToId(link)}`}>
      <Link to={link} className="e2e-breadcrumb new-breadcrumbs__link" aria-label={ariaLabel}>
        <div className="new-breadcrumbs__link-content new-breadcrumbs__clip-content">
          {!isEmpty(iconName) ? (
            <svg className="svg-icon svg-icon--medium new-breadcrumbs__icon">
              <use xlinkHref={`#icon-${iconName}`} />
            </svg>
          ) : null}
          <span className="new-breadcrumbs__label">{label}</span>
        </div>
      </Link>
      {!!children && (
        <RsBreadcrumbTooltip id={`tooltip-${linkToId(link)}`}>
          <div className="new-breadcrumbs__tooltip-content tooltip-content-breadcrumb">{children}</div>
        </RsBreadcrumbTooltip>
      )}
    </li>
  );
}

RsBreadcrumbItem.propTypes = {
  link: PropTypes.string.isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  iconName: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  ariaLabel: PropTypes.string,
};

export default RsBreadcrumbItem;
